import React from 'react';
import './Common.css';

/**
 * Компонент для отображения сообщений об ошибках
 */
const ErrorMessage = ({ message }) => {
  if (!message) return null;

  return <div className="error-message">{message}</div>;
};

export default ErrorMessage;
